import api from './api';
// 根据类型Id获取模块列表
export function getAllianceListByTypeId(params) {
  return api.post('/org/list', params, false, false).then(res => res);
}
// 新增模块信息
export function addAlliance(params) {
  return api.post('/org/save.html', params, false, false).then(res => res);
}
// 删除模块信息
export function deleteAlliance(params) {
  return api.post('/org/delet.html', params, false, false).then(res => res);
}
// 修改模块信息
export function updateAlliance(params) {
  return api.post('/org/update.html', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/alliance.js